"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5285],{

/***/ 8316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Y": function() { return /* binding */ buttonStyles; }
/* harmony export */ });
/* unused harmony export borderRadiusButtonValues */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8690);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99278);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37138);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67113);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26521);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};





var borderRadiusButtonValues = ['none', 'sm', 'md', 'lg'];
var isValidBorderRadius = function (size) { return size && borderRadiusButtonValues.includes(size); };
var sizes = {
    small: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: ", ";\n    font-size: ", "px;\n    padding: 7px 12px;\n  "], ["\n    border-radius: ", ";\n    font-size: ", "px;\n    padding: 7px 12px;\n  "])), function (props) {
        return (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("borderRadii.".concat(isValidBorderRadius(props.borderRadius) ? props.borderRadius : 'action-sm'))(props);
    }, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('fontSizes.0')),
    medium: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: ", ";\n    font-size: ", "px;\n    padding: 9.5px 18px;\n  "], ["\n    border-radius: ", ";\n    font-size: ", "px;\n    padding: 9.5px 18px;\n  "])), function (props) {
        return (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("borderRadii.".concat(isValidBorderRadius(props.borderRadius) ? props.borderRadius : 'action-md'))(props);
    }, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('fontSizes.1')),
    large: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-radius: ", ";\n    font-size: ", "px;\n    padding: 12px 22px;\n  "], ["\n    border-radius: ", ";\n    font-size: ", "px;\n    padding: 12px 22px;\n  "])), function (props) {
        return (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("borderRadii.".concat(isValidBorderRadius(props.borderRadius) ? props.borderRadius : 'action-lg'))(props);
    }, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('fontSizes.2')),
};
var variations = {
    fill: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n\n    &:hover {\n      background-color: ", ";\n      ", "\n    }\n    &:focus {\n      outline: ", ";\n      box-shadow: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    color: ", ";\n\n    &:hover {\n      background-color: ", ";\n      ", "\n    }\n    &:focus {\n      outline: ", ";\n      box-shadow: ", ";\n    }\n  "])), function (props) { return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)(props.disabled ? 'light' : 'base')(props); }, function (props) { return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getTextColorOn */ .MI)(props.disabled ? 'light' : 'base')(props); }, function (props) { return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)(props.disabled ? 'light' : 'dark')(props); }, function (props) { return (props.disabled ? '' : "color: ".concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getTextColorOn */ .MI)('dark')(props), ";")); }, function (props) { return "0px solid ".concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)(props.disabled ? '' : 'dark')(props)); }, function (props) { return " 0 0 0 2px  ".concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)(props.disabled ? '' : 'dark')(props)); }),
    link: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    -webkit-font-smoothing: inherit;\n    font-weight: ", ";\n    color: ", ";\n    line-height: ", ";\n    vertical-align: inherit;\n    padding: 0;\n    background-color: transparent;\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  "], ["\n    -webkit-font-smoothing: inherit;\n    font-weight: ", ";\n    color: ", ";\n    line-height: ", ";\n    vertical-align: inherit;\n    padding: 0;\n    background-color: transparent;\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  "])), function (props) { return props.theme.fontWeights.medium; }, (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('base'), function (props) { return props.theme.lineHeights.standard; }, (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark')),
    outline: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    box-shadow: inset 0 0 0 2px ", ";\n    background-color: transparent;\n\n    &:hover {\n      background-color: transparent;\n      ", "\n    }\n  "], ["\n    color: ", ";\n    box-shadow: inset 0 0 0 2px ", ";\n    background-color: transparent;\n\n    &:hover {\n      background-color: transparent;\n      ", "\n    }\n  "])), function (props) { return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)(props.disabled ? 'light' : 'base')(props); }, function (props) { return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)(props.disabled ? 'light' : 'base')(props); }, function (props) {
        return props.disabled
            ? ''
            : "\n      color: ".concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark')(props), ";\n      box-shadow: inset 0 0 0 2px ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark')(props), ";\n    ");
    }),
    plain: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    background-color: transparent;\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:focus {\n      outline: 0px solid ", ";\n      box-shadow: 0 0 0 2px ", ";\n    }\n  "], ["\n    background-color: transparent;\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:focus {\n      outline: 0px solid ", ";\n      box-shadow: 0 0 0 2px ", ";\n    }\n  "])), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('base'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('background.light'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark')),
    subtle: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:focus {\n      outline: 0px solid ", ";\n      box-shadow: 0 0 0 2px ", ";\n    }\n  "], ["\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:focus {\n      outline: 0px solid ", ";\n      box-shadow: 0 0 0 2px ", ";\n    }\n  "])), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('background.base'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('base'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('background.light'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark')),
    white: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:focus {\n      outline: 0px solid ", ";\n      box-shadow: 0 0 0 2px ", ";\n    }\n  "], ["\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:focus {\n      outline: 0px solid ", ";\n      box-shadow: 0 0 0 2px ", ";\n    }\n  "])), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('background.lightest'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('base'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('background.light'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark')),
    lightFill: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:focus {\n      outline: ", ";\n      box-shadow: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:focus {\n      outline: ", ";\n      box-shadow: ", ";\n    }\n  "])), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('light'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('base'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('light'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark'), function (props) { return "0px solid ".concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)(props.disabled ? '' : 'dark')(props)); }, function (props) { return " 0 0 0 2px  ".concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)(props.disabled ? '' : 'dark')(props)); }),
};
var buttonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-family: inherit;\n  font-weight: ", ";\n  line-height: 1.5;\n  cursor: ", ";\n  border-radius: ", ";\n  border-width: 0;\n  border-style: solid;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n\n  &:disabled {\n    cursor: not-allowed;\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-family: inherit;\n  font-weight: ", ";\n  line-height: 1.5;\n  cursor: ", ";\n  border-radius: ", ";\n  border-width: 0;\n  border-style: solid;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n\n  &:disabled {\n    cursor: not-allowed;\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (props) { return props.theme.fontWeights.bold; }, function (props) { return (props.disabled ? 'default' : 'pointer'); }, function (props) { return props.theme.radius; }, function (_a) {
    var theme = _a.theme;
    return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .applySizes */ .BS)(sizes, 'medium', theme.mediaQueries);
}, (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyVariations */ .hO)('Button', variations), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .width */ .bf, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .boxShadow */ .Wn, (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('text.light'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('background.base'));
var propTypes = __assign(__assign(__assign(__assign(__assign({ size: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf(['small', 'medium', 'large']) }, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .width.propTypes */ .bf.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space.propTypes */ .Dh.propTypes), { fullWidth: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .deprecatedPropType */ .aR)('width'), variation: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf(Object.keys(variations)), color: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .deprecatedColorValue */ .nL)(), disabled: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool) }), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .boxShadow.propTypes */ .Wn.propTypes), { borderRadius: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf(borderRadiusButtonValues), boxShadowSize: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf(__spreadArray([''], _utils__WEBPACK_IMPORTED_MODULE_5__/* .boxShadowSizeValues */ .d, true)) });
/**
 * Use the <Button /> component to render a primitive button. Use the `variation` prop to change the look of the button.
 */
var Button = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.attrs */ .ZP.button.attrs(function (props) {
    var width = props.width, fullWidth = props.fullWidth, title = props.title, ariaLabel = props["aria-label"], borderRadius = props.borderRadius;
    return __assign(__assign({ borderRadius: borderRadius }, (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .boxShadowAttrs */ .v)(props)), { width: fullWidth ? 1 : width, 'aria-label': ariaLabel || title });
})(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), buttonStyles);
Button.propTypes = propTypes;
Button.defaultProps = {
    color: 'primary',
    size: 'medium',
    variation: 'fill',
};
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["ZP"] = (Button);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=Button.js.map

/***/ }),

/***/ 92833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99278);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92591);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67113);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var propTypes = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .space.propTypes */ .Dh.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_0__/* .width.propTypes */ .bf.propTypes), { color: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .deprecatedColorValue */ .nL)(), bg: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .deprecatedPropType */ .aR)('color') }), styled_system__WEBPACK_IMPORTED_MODULE_0__/* .alignItems.propTypes */ .cq.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_0__/* .justifyContent.propTypes */ .Kl.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_0__/* .flexWrap.propTypes */ .WO.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_0__/* .flexDirection.propTypes */ .Me.propTypes), { wrap: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .deprecatedPropType */ .aR)('flexWrap'), align: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .deprecatedPropType */ .aR)('alignItems'), justify: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .deprecatedPropType */ .aR)('justifyContent') });
var Flex = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function (_a) {
    var wrap = _a.wrap, align = _a.align, justify = _a.justify, props = __rest(_a, ["wrap", "align", "justify"]);
    return (__assign({ flexWrap: wrap ? 'wrap' : undefined, alignItems: align, justifyContent: justify }, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  ", "\n  ", " ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  ", "\n  ", " ", "\n  ", "\n  ", "\n"])), (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .applyVariations */ .hO)('Flex'), styled_system__WEBPACK_IMPORTED_MODULE_0__/* .alignItems */ .cq, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .justifyContent */ .Kl, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .flexDirection */ .Me, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .flexWrap */ .WO);
Flex.propTypes = propTypes;
Flex.displayName = 'Flex';
/* harmony default export */ __webpack_exports__["Z"] = (Flex);
var templateObject_1;
//# sourceMappingURL=Flex.js.map

/***/ }),

/***/ 14649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8690);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8316);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67113);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var TransparentButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  background-color: transparent;\n  color: inherit;\n\n  &:hover {\n    background-color: transparent;\n    color: inherit;\n  }\n  & > div {\n    display: flex;\n  }\n  &:disabled {\n    background-color: transparent;\n  }\n\n  ", "\n"], ["\n  padding: 0;\n  background-color: transparent;\n  color: inherit;\n\n  &:hover {\n    background-color: transparent;\n    color: inherit;\n  }\n  & > div {\n    display: flex;\n  }\n  &:disabled {\n    background-color: transparent;\n  }\n\n  ", "\n"])), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .applyVariations */ .hO)('IconButton'));
var propTypes = {
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
};
var IconButton = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (_a, ref) {
    var icon = _a.icon, props = __rest(_a, ["icon"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransparentButton, __assign({}, props, { ref: ref }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, icon)));
});
IconButton.displayName = 'IconButton';
IconButton.isIconButton = true;
IconButton.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["Z"] = (IconButton);
var templateObject_1;
//# sourceMappingURL=IconButton.js.map

/***/ }),

/***/ 40869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8690);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99278);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8316);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67113);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var variations = {
    fill: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &:hover {\n      text-decoration: none;\n    }\n\n    ", "\n  "], ["\n    &:hover {\n      text-decoration: none;\n    }\n\n    ", "\n  "])), _Button__WEBPACK_IMPORTED_MODULE_1__/* .buttonStyles */ .$Y),
    link: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n    text-decoration: none;\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  "], ["\n    cursor: pointer;\n    text-decoration: none;\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  "])), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('base'), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getPaletteColor */ .ow)('dark')),
    outline: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &:hover {\n      text-decoration: none;\n    }\n\n    ", "\n  "], ["\n    &:hover {\n      text-decoration: none;\n    }\n\n    ", "\n  "])), _Button__WEBPACK_IMPORTED_MODULE_1__/* .buttonStyles */ .$Y),
};
var propTypes = {
    color: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .deprecatedColorValue */ .nL)(),
    variation: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(Object.keys(variations)),
};
var Link = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.attrs */ .ZP.a.attrs(function (_a) {
    var target = _a.target, props = __rest(_a, ["target"]);
    return (__assign({ rel: target === '_blank' ? 'noopener' : null, target: target }, props));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", " ", ";\n"], ["\n  ", "\n  ", " ", ";\n"])), (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyVariations */ .hO)('Link', variations), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .width */ .bf, styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
Link.displayName = 'Link';
Link.defaultProps = {
    color: 'primary',
    variation: 'link',
    size: 'medium',
};
Link.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["Z"] = (Link);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Link.js.map

/***/ }),

/***/ 23720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Text_Text; }
});

// UNUSED EXPORTS: bold, caps, regular, textDecoration, textShadow

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/node_modules/prop-types/index.js
var prop_types = __webpack_require__(8690);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js
var index_esm = __webpack_require__(99278);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
;// CONCATENATED MODULE: ./node_modules/pcln-design-system/lib-esm/utils/attrs/typographyAttrs.js
var textStylesValues = [
    'title1',
    'title2',
    'title3',
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    'article',
    'articleBold',
    'paragraph',
    'paragraphBold',
    'paragraph2',
    'paragraph2Bold',
    'caption',
    'captionBold',
    'overline',
    'overlineMedium',
    'disclaimer',
    'disclaimerBold',
    'highlight',
    'highlightBold',
    'subtitle1',
    'subheading1',
    'subheading2',
    'subheading3',
    'subheading4',
    'subheading5',
    'subheading6',
];
function typographyAttrs(props) {
    var textStyle = props.textStyle, theme = props.theme;
    if (!textStyle) {
        return {};
    }
    if (Array.isArray(textStyle)) {
        var styles = textStyle.map(function (style) { return theme.typography[style]; });
        return styles.reduce(function (acc, style) {
            var styleProps = style && style.hasOwnProperty('fontSize') ? Object.keys(style) : [];
            if (styleProps.length === 0) {
                // Fill in null values for this index of textStyles if null/undefined provided
                // (exclude caps because we don't handle responsive caps yet)
                ;
                ['fontSize', 'fontWeight', 'lineHeight', 'letterSpacing', 'textTransform'].forEach(function (styleProp) {
                    acc[styleProp].push(null);
                });
            }
            else {
                styleProps.forEach(function (styleProp) {
                    acc[styleProp].push(style[styleProp]);
                });
            }
            return acc;
        }, {
            fontSize: [],
            fontWeight: [],
            lineHeight: [],
            letterSpacing: [],
            caps: [],
            textTransform: [],
        });
    }
    else {
        return theme.typography[textStyle];
    }
}
//# sourceMappingURL=typographyAttrs.js.map
;// CONCATENATED MODULE: ./node_modules/pcln-design-system/lib-esm/utils/attrs/textAlignAttrs.js
// TODO
// supports deprecated `align` prop
// remove in v5
function textAlignAttrs(props) {
    var align = props.align, textAlign = props.textAlign;
    return {
        textAlign: textAlign ? textAlign : align,
    };
}
//# sourceMappingURL=textAlignAttrs.js.map
;// CONCATENATED MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var caps = function (props) {
    if (Array.isArray(props.caps) && props.caps.length === 0) {
        return null;
    }
    return (props === null || props === void 0 ? void 0 : props.caps)
        ? {
            textTransform: 'uppercase',
        }
        : null;
};
var regular = function (props) { return (props.regular ? { fontWeight: props.theme.regular } : null); };
var bold = function (props) {
    if (Array.isArray(props.bold) && props.bold.length === 0) {
        return null;
    }
    return props.bold ? { fontWeight: props.theme.bold } : null;
};
var textDecoration = function (props) {
    return props.textDecoration ? "text-decoration: ".concat(props.textDecoration, ";") : '';
};
var textShadow = function (props) {
    var textShadowSize = props.textShadowSize || 'md';
    return props.enableTextShadow ? { textShadow: props.theme.textShadows[textShadowSize] } : null;
};
var textProps = (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  color: ", ";\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), (0,utils/* applyVariations */.hO)('Text'), (0,utils/* getPaletteColor */.ow)('base'), function (props) { return (props.bg ? "background-color: ".concat((0,utils/* getPaletteColor */.ow)(props.bg, 'base')(props), ";") : ''); }, index_esm/* display */.jf, index_esm/* height */.Cb, index_esm/* maxHeight */.kC, index_esm/* maxWidth */.kk, index_esm/* minHeight */.jw, index_esm/* minWidth */.ih, index_esm/* overflow */.tx, index_esm/* space */.Dh, index_esm/* width */.bf, caps, regular, bold, index_esm/* fontSize */.JB, index_esm/* fontStyle */.p_, index_esm/* fontWeight */.Ue, index_esm/* lineHeight */.Nv, index_esm/* letterSpacing */.rX, index_esm/* textAlign */.yd, textDecoration, textShadow, index_esm/* textStyle */.YK, index_esm/* zIndex */.W5);
var textAttrs = function (props) { return (__assign(__assign({}, typographyAttrs(props)), textAlignAttrs(props))); };
var Text = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(textAttrs)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textProps);
var Span = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs(textAttrs)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textProps);
var Paragraph = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(textAttrs)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textProps);
var Strike = styled_components_browser_esm/* default.s.attrs */.ZP.s.attrs(textAttrs)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textProps);
Text.displayName = 'Text';
Text.propTypes = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, index_esm/* display.propTypes */.jf.propTypes), index_esm/* fontSize.propTypes */.JB.propTypes), index_esm/* fontStyle.propTypes */.p_.propTypes), index_esm/* fontWeight.propTypes */.Ue.propTypes), index_esm/* height.propTypes */.Cb.propTypes), index_esm/* lineHeight.propTypes */.Nv.propTypes), index_esm/* maxHeight.propTypes */.kC.propTypes), index_esm/* maxWidth.propTypes */.kk.propTypes), index_esm/* minHeight.propTypes */.jw.propTypes), index_esm/* minWidth.propTypes */.ih.propTypes), index_esm/* overflow.propTypes */.tx.propTypes), index_esm/* space.propTypes */.Dh.propTypes), index_esm/* textAlign.propTypes */.yd.propTypes), index_esm/* textStyle.propTypes */.YK.propTypes), index_esm/* width.propTypes */.bf.propTypes), index_esm/* zIndex.propTypes */.W5.propTypes), { align: (0,utils/* deprecatedPropType */.aR)('textAlign'), bold: (prop_types_default()).bool, caps: (prop_types_default()).bool, color: (0,utils/* deprecatedColorValue */.nL)(), enableTextShadow: (prop_types_default()).bool, regular: (prop_types_default()).bool, textDecoration: (prop_types_default()).string, textShadowSize: prop_types_default().oneOf(['sm', 'md']), textStyle: prop_types_default().oneOf(textStylesValues) });
Text.span = Span;
Text.span.displayName = 'Text.span';
Text.p = Paragraph;
Text.p.displayName = 'Text.p';
Text.s = Strike;
Text.s.displayName = 'Text.s';
/* harmony default export */ var Text_Text = (Text);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Text.js.map

/***/ }),

/***/ 75271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z"
  }));
};

var SvgClose = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Close__SvgClose",
  componentId: "sc-14nkhxm-0"
})(["outline:none;"]);
SvgClose.isIcon = true;
SvgClose.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);

/***/ }),

/***/ 51557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99278);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37138);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/**
 * Gets the color of a palette shade, using props.color as
 * the palette color. If palette shade does not exist, falls
 * back to theme.colors
 *
 * @see This function is a copy of the core function located
 * in /core/src/utils.js in order to avoid circular issues
 *
 * @example getPaletteColor('dark')(props) => will return the dark
 * shade of theme.palette[props.color].dark
 * @example getPaletteColor('primary.base')(props) => theme.palette.primary.base
 * @example getPaletteColor('primary', 'base')(props) => theme.palette.primary.base
 */

var getPaletteColor = function getPaletteColor() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (props) {
    var color = args.length === 2 ? args[0] : props.color;
    var shade = args.length === 2 ? args[1] : args[0];
    var colorShade = shade.match(/^([a-z]+)\.([a-z]+)$/);

    if (colorShade) {
      color = colorShade[0];
      shade = colorShade[1];
    }

    return (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("palette.".concat(color, ".").concat(shade))(props) || (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("palette.".concat(color))(props) || (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("colors.".concat(color))(props) || color;
  };
};

var color = function color(props) {
  if (props.color) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["color:", ";"], getPaletteColor('base')(props));
  }

  return null;
};

var bg = function bg(props) {
  if (props.bg) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["background-color:", ";"], getPaletteColor(props.bg, 'base')(props));
  }

  return null;
};

var Svg = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)('svg').withConfig({
  displayName: "Svg",
  componentId: "sc-12lgb6u-0"
})(["flex:none;line-height:1;", " ", " ", " ", ""], styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf, color, bg);
Svg.propTypes = _objectSpread(_objectSpread(_objectSpread({}, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space.propTypes */ .Dh.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_2__/* .width.propTypes */ .bf.propTypes), color.propTypes);
/* harmony default export */ __webpack_exports__["Z"] = (Svg);

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);